export default __webpack_public_path__ + "static/media/question_yellow.8a4c3ac4.svg";